import { useClaims } from '@backoffice-frontend/authentication'
import { useErrorHandlingQuery } from '@backoffice-frontend/data-fetching'
import { useBackofficeUserByEmailQuery } from './graphql/userByEmail.hook'

/**
 * A hook that combines useLoggedInUserEmail and useBackofficeUser to return the User object for the currentAuthenticatedUser
 * @returns user
 */
export const useBackofficeLoggedInUser = () => {
  const email = useLoggedInUserEmail()
  const { data, loading } = useErrorHandlingQuery(
    useBackofficeUserByEmailQuery,
    {
      variables: { email },
      skip: !email,
    },
  )

  return {
    loading,
    user:
      data?.backofficeUserByEmail?.__typename === 'BackofficeUser'
        ? data.backofficeUserByEmail
        : undefined,
  }
}

export const useLoggedInUserEmail = () => {
  const claims = useClaims()
  return claims.cognito.email()
}

export const getFullNameFromUser = (user?: {
  firstName?: string
  lastName?: string
}) => {
  return `${user?.firstName ?? ''} ${user?.lastName ?? ''}`
}
